import { Building2, CreditCard, HardDrive, LogOut, Palette, Plug, Tag } from 'lucide-react';
import { Link, Outlet, useNavigate } from 'react-router-dom';
import { useAuthStore } from '@/lib/auth-store';
import { useBranding } from '@/lib/use-branding';

export function AdminShell() {
  const user = useAuthStore((s) => s.user);
  const signOut = useAuthStore((s) => s.signOut);
  const navigate = useNavigate();
  const { branding } = useBranding();

  async function handleSignOut() {
    await signOut();
    navigate('/sign-in', { replace: true });
  }

  return (
    <div className="min-h-screen bg-neutral-950 text-neutral-100">
      <header className="border-b border-neutral-800 bg-neutral-900">
        <div className="mx-auto flex h-14 max-w-7xl items-center justify-between px-6">
          <Link
            to="/admin"
            className="flex items-center gap-2 text-sm font-semibold tracking-tight"
            style={{ color: branding?.headerTextColor ?? undefined }}
          >
            {branding?.brandingEnabled && branding.headerLogoUrl ? (
              <img
                src={branding.headerLogoUrl}
                alt={branding.headerName ?? 'Logo'}
                className="logo-shadow-light h-7 object-contain"
              />
            ) : (
              <span className="inline-flex h-7 w-7 items-center justify-center rounded-md bg-neutral-100 text-neutral-900">
                V
              </span>
            )}
            {branding?.brandingEnabled && branding.headerLogoUrl
              ? null
              : `${branding?.headerName ?? 'VoxisAdv'} Admin`}
          </Link>
          <div className="flex items-center gap-4">
            {user?.email && (
              <span className="text-sm text-neutral-400">{user.email}</span>
            )}
            <button
              type="button"
              onClick={handleSignOut}
              className="inline-flex items-center gap-2 rounded-md px-3 py-1.5 text-sm text-neutral-300 hover:bg-neutral-800"
            >
              <LogOut className="h-4 w-4" />
              Sair
            </button>
          </div>
        </div>
      </header>

      <div className="mx-auto flex max-w-7xl gap-6 px-6 py-6">
        <aside className="w-56 shrink-0">
          <nav className="flex flex-col gap-1">
            <Link
              to="/admin/clientes"
              className="flex items-center gap-2 rounded-md px-3 py-2 text-sm font-medium text-neutral-300 hover:bg-neutral-800"
            >
              <Building2 className="h-4 w-4" />
              Clientes
            </Link>
            <Link
              to="/admin/aparencia"
              className="flex items-center gap-2 rounded-md px-3 py-2 text-sm font-medium text-neutral-300 hover:bg-neutral-800"
            >
              <Palette className="h-4 w-4" />
              Aparencia
            </Link>
            <Link
              to="/admin/integracoes"
              className="flex items-center gap-2 rounded-md px-3 py-2 text-sm font-medium text-neutral-300 hover:bg-neutral-800"
            >
              <Plug className="h-4 w-4" />
              Integrações
            </Link>
            <Link
              to="/admin/planos"
              className="flex items-center gap-2 rounded-md px-3 py-2 text-sm font-medium text-neutral-300 hover:bg-neutral-800"
            >
              <CreditCard className="h-4 w-4" />
              Planos
            </Link>
            <Link
              to="/admin/cupons"
              className="flex items-center gap-2 rounded-md px-3 py-2 text-sm font-medium text-neutral-300 hover:bg-neutral-800"
            >
              <Tag className="h-4 w-4" />
              Cupons
            </Link>
            <Link
              to="/admin/armazenamento"
              className="flex items-center gap-2 rounded-md px-3 py-2 text-sm font-medium text-neutral-300 hover:bg-neutral-800"
            >
              <HardDrive className="h-4 w-4" />
              Gerenciador de disco
            </Link>
          </nav>
        </aside>

        <main className="flex-1 min-w-0">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
